import PropTypes from 'prop-types';

export const SiteBuilderAgentSuccessProps = {
  locales: PropTypes.object.isRequired,
  handleRequestBuilderSso: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onEditAgent: PropTypes.func.isRequired,
  onAgentSwitch: PropTypes.func.isRequired,
};
